module.exports = __webpack_public_path__ + "static/media/photo_9.3fe4b6e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/photo_9.jpg
// module id = 1642
// module chunks = 0